import {getPlatform} from './getPlatform';
import {isMobileDevice} from './isMobileDevice';
import {clcPercentage} from './clcPercentage';
import {rowCenterSpcBtwWrap} from './rowCenterSpcBtwWrap';

import scrollToTop from './scrollToTop';

import getTabs from './getTabs';
import rowSpcBtw from './rowSpcBtw';
import rowCenter from './rowCenter';
import flexCenter from './flexCenter';
import columnCenter from './columnCenter';
import numberOfLines from './numberOfLines';
import rowCenterWrap from './rowCenterWrap';
import rowCenterSpcBtw from './rowCenterSpcBtw';
import rowWrapSpcBtween from './rowWrapSpcBtween';
import rowCenterFlexEnd from './rowCenterFlexEnd';
import rowCenterSpcAround from './rowCenterSpcAround';
import columnCenterSpcBtween from './columnCenterSpcBtween';

export const utils = {
  getTabs,
  rowCenter,
  flexCenter,
  rowSpcBtw,
  scrollToTop,
  getPlatform,
  columnCenter,
  numberOfLines,
  rowCenterWrap,
  clcPercentage,
  isMobileDevice,
  rowWrapSpcBtween,
  rowCenterFlexEnd,
  rowCenterSpcBtw,
  rowCenterSpcAround,
  rowCenterSpcBtwWrap,
  columnCenterSpcBtween,
};
